export const OPERATIONAL_CHUNK_SECONDS = 10 * 60;

export function buildChunkPlan({ startSeconds, endSeconds, chunkSeconds = OPERATIONAL_CHUNK_SECONDS }) {
  if (!Number.isFinite(startSeconds) || !Number.isFinite(endSeconds) || startSeconds < 0 || endSeconds <= startSeconds) {
    throw new Error('Invalid transcription range.');
  }

  const plan = [];
  for (let start = startSeconds; start < endSeconds; start += chunkSeconds) {
    plan.push({ startSeconds: start, durationSeconds: Math.min(chunkSeconds, endSeconds - start) });
  }
  return plan;
}

export function offsetChunks(chunks, offsetSeconds) {
  return chunks.map((chunk) => ({
    ...chunk,
    timestamp: [
      Number(chunk.timestamp?.[0] || 0) + offsetSeconds,
      Number(chunk.timestamp?.[1] || 0) + offsetSeconds,
    ],
  }));
}

function throwIfAborted(signal) {
  if (signal?.aborted) throw new DOMException('Transcription cancelled.', 'AbortError');
}

export async function runTranscriptionSession({
  endSeconds,
  extractChunk,
  file,
  onChunk,
  onProgress,
  signal,
  startSeconds,
  transcribe,
}) {
  const plan = buildChunkPlan({ startSeconds, endSeconds });
  const output = [];

  for (let index = 0; index < plan.length; index += 1) {
    throwIfAborted(signal);
    const item = plan[index];
    onProgress?.({ currentChunk: index + 1, totalChunks: plan.length });
    const audio = await extractChunk(file, item, signal);
    throwIfAborted(signal);
    const result = await transcribe(audio, signal);
    const chunks = offsetChunks(result.chunks, item.startSeconds);
    output.push(...chunks);
    onChunk?.(chunks);
  }

  return output;
}
